import IntroductionDialog from 'components/Feedback/IntroductionDialog';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import ErrorPage from 'pages/Error/404';
import { PageContext } from 'pages/StudentViewAssignmentFeedback/PageProvider';
import Desktop from 'pages/StudentViewAssignmentFeedback/desktop';
import Mobile from 'pages/StudentViewAssignmentFeedback/mobile';
import Tablet from 'pages/StudentViewAssignmentFeedback/tablet';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading, assignments, currentAssignmentId, currentAssignment, feedback } = useApp();
    const params = useParams();
    const { device } = useViewport();

    const props = useContext(PageContext);

    const { currentFeedback, introductionDialog, setIntroductionDialog } = props;

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (isLoading || currentAssignmentId !== params.id || !feedback) return <Loading />;

    if ((assignments && !currentAssignment) || !currentFeedback) return <ErrorPage />;

    return (
        <>
            {renderResponsiveLayout(device)}
            <IntroductionDialog open={introductionDialog.open} onClose={() => setIntroductionDialog({ open: false })} />
        </>
    );
};

export default PageLayout;
